<template>
  <div style="background-color: #fff">
    <div style="margin: 20px ;font-size: 18px; color: #1890ff; text-align: center" v-show="inputShow">
      <span>公司名称:</span>
      <a-input style="margin: 0px 10px;width: 200px" v-model="companyName" type="text" @keyup.enter="onselect"></a-input>
      <a-button
        type="primary"
        icon="search"
        style="width: 90px; margin-left: 20px" @click="onselect"
      >查找</a-button>
    </div>
    <div class="companyInfo" v-show="!companyVisible">
      <p>客户编码：{{companyData.fnumber}}</p>
      <p>客户名称：{{companyData.fname}}</p>
      <p>客户地址：{{companyData.fshrdz}}</p>
      <p>联系人：{{companyData.fshr}}</p>
      <p>手机号码：{{companyData.fshrdh}}</p>
      <p>创建时间：{{companyData.fcreatedate}}</p>
      <p>最后修改时间：{{companyData.fmodifydate}}</p>
      <div style="clear:both"></div>
      <a-button type="primary" @click="addMachineInfo">新增</a-button>
      <a-button type="primary" @click="editMachineInfo">编辑</a-button>
      <a-button type="primary" @click="removeMachineInfo">删除</a-button>
      <a-button type="primary" @click="goback()">返回</a-button>
      <a-modal :visible="deletevisible" title="确认框" @ok="handledelete" @cancel="deletevisible = false">
        <p>
          确定要删除吗？
        </p>
      </a-modal>
    </div>
    <a-table :columns="companyColumns" :data-source="companyList" :rowKey="(_, index) => index"
    :customRow="clickRow" v-show="companyVisible"></a-table>
    <a-table :columns="machineColumns" :data-source="machineList" :rowKey="(item, index) => item.id"
    v-show="!companyVisible" :row-selection="rowSelection" :loading="loading" :customRow="machineRow">
    </a-table>
    <!-- <a-table :columns="machineColumns" :data-source="machineList" :rowKey="(_, index) => index"
    v-show="machineVisible" :row-selection="rowSelection" :loading="loading"></a-table> -->
    <a-modal :visible="visible" title="设备信息" @ok="handleOk" @cancel="handleCancel">
      <p><span>整机编号：</span><input type="text" v-model="insertData.machineId"></p>
      <p><span>机型：</span><input type="text" v-model="insertData.machineType"></p>
      <p><span>业务员：</span><input type="text" v-model="insertData.salesman"></p>
      <p><span>服务员：</span><input type="text" v-model="insertData.serviceName"></p>
      <p><span>备注：</span><input type="text" v-model="insertData.remark"></p>
      <p><span>保养时间：</span><input type="text" v-model="maintainSetTime"></p>
      <p><span>每天运行时间：</span><input type="text" v-model="runtime"></p>
      <p><span>价格：</span><input type="text" v-model="price" /></p>
      <p><span>出厂日期：</span><a-date-picker @change="salesTimeChange" v-model="salesTime" /></p>
      <p><span>上次保养日期：</span><a-date-picker @change="lastChange" v-model="lastMaintainTime" class="lastMaintainTime"/></p>
      <p><span>剩余保养天数：</span><input disabled="disabled" type="text" :value="maintainDate" class="exceptMaintainDate" ></p>
      <p><span>下次保养日期：</span><input disabled :value="exceptMaintainDate" class="exceptMaintainDate" /></p>
    </a-modal>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import crmApi from '../../../api/crmreport'
import machineApi from '../../../api/machine'
import { companyColumns, machineColumns } from './data'
import moment from 'moment'
import { nanoid } from 'nanoid'

export default {
  name: 'customeService',
  data () {
    return {
      inputShow: true,
      companyName: '',
      companyColumns,
      machineColumns,
      companyList: [],
      companyVisible: true,
      companyData: {},
      visible: false,
      loading: false,
      machineVisible: false,
      deletevisible: false,
      currentPage: 1,
      pageSize: 10,
      machineList: [],
      insertData: {},
      selectedMachineList: [],
      runtime: '',
      price: '',
      lastMaintainTime: '',
      maintainSetTime: '',
      salesTime: '',
      flag: 0,
      index: 0,
      rowSelection: {
        preserveSelectedRowKeys: false,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          this.selectedMachineList = selectedRows
          console.log(selectedRows)
          this.$forceUpdate()
        }
      },
      routeFlag: 0
    }
  },
  watch: {
    maintainSetTime () {
      this.insertData.maintainSetTime = this.maintainSetTime
    },
    runtime () {
      this.insertData.runtime = this.runtime
    },
    lastMaintainTime () {
      this.insertData.lastMaintainTime = this.lastMaintainTime
    },
    salesTime () {
      this.insertData.salesTime = this.salesTime
    },
    price () {
      this.insertData.price = this.price
    }
  },
  async created () {
    if (this.$route.query.companyName) {
      this.inputShow = false
      this.companyVisible = false
      await this.getreportlist(this.$route.query.companyName)
      this.routeFlag = 1
      this.inputShow = false
      const record = this.companyList[0]
      this.companyVisible = false
      record.fcreatedate = record.fcreatedate.slice(0, 19)
      record.fmodifydate = record.fmodifydate.slice(0, 19)
      this.companyData = record
      console.log(this.companyData)
      // this.salesman = this.currentData.salesman
      const reportData = await machineApi.getMachineList(record.fcustId, this.currentPage, this.pageSize)
      reportData.records.forEach((item, index) => {
        item.lastMaintainTime = this.formatDate(item.lastMaintainTime)
        item.salesTime = this.formatDate(item.salesTime)
        item.exceptMaintainDate = this.formatDate(item.exceptMaintainDate)
      })
      console.log(reportData)
      reportData.records.forEach(record => {
        record.exceptMaintainDate = record.exceptMaintainDate === '1970-01-01' ? '' : record.exceptMaintainDate
        record.lastMaintainTime = record.lastMaintainTime === '1970-01-01' ? '' : record.lastMaintainTime
        record.salesTime = record.salesTime === '1970-01-01' ? '' : record.salesTime
        if (!record.id) {
          record.id = nanoid()
          record.remark = '(已监控)'
        }
        console.log(record)
      })
      console.log(reportData)
      // reportData.salesTime = this.formatDate(reportData.salesTime)
      // reportData.salesTime = this.formatDate(reportData.expectMaintainDate)
      this.machineList = reportData.records.reverse()
    }
  },
  methods: {
    moment,
    formatDate (timeStamp) {
      const date = new Date(timeStamp)
      const Y = date.getFullYear()
      const M = (date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1
      const D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return (Y + '-' + M + '-' + D)
    },
    clickRow (record, index) {
      return {
        on: {
          click: async () => {
            this.inputShow = false
            console.log(record)
            this.companyVisible = false
            record.fcreatedate = record.fcreatedate.slice(0, 19)
            record.fmodifydate = record.fmodifydate.slice(0, 19)
            this.companyData = record
            console.log(this.companyData)
            // this.salesman = this.currentData.salesman
            const reportData = await machineApi.getMachineList(record.fcustId, this.currentPage, this.pageSize)
            reportData.records.forEach((item, index) => {
              item.lastMaintainTime = this.formatDate(item.lastMaintainTime)
              item.salesTime = this.formatDate(item.salesTime)
              item.exceptMaintainDate = this.formatDate(item.exceptMaintainDate)
            })
            console.log(reportData)
            reportData.records.forEach(record => {
              record.exceptMaintainDate = record.exceptMaintainDate === '1970-01-01' ? '' : record.exceptMaintainDate
              record.lastMaintainTime = record.lastMaintainTime === '1970-01-01' ? '' : record.lastMaintainTime
              record.salesTime = record.salesTime === '1970-01-01' ? '' : record.salesTime
              if (!record.id) {
                record.id = nanoid()
                record.remark = '(已监控)'
              }
              console.log(record)
            }
            )
            console.log(reportData)
            // reportData.salesTime = this.formatDate(reportData.salesTime)
            // reportData.salesTime = this.formatDate(reportData.expectMaintainDate)
            this.machineList = reportData.records.reverse()
          }
        }
      }
    },
    machineRow (record, index) {
      return {
        on: {
          click: () => {
            console.log(record)
            this.machineVisible = true
          }
        }
      }
    },
    onselect () {
      const companyName = this.companyName?.trim()
      if (!companyName) {
        return message.warn('输入词不能为空')
      }
      this.getreportlist(companyName)
      this.companyName = ''
    },
    async getreportlist (companyName) {
      this.loading = true
      try {
        const result = await crmApi.searchCompany(companyName)
        if (result.length === 0) {
          return message.warn('未搜索到该公司')
        }
        this.companyList = result
      } catch {
        this.$message.error('请求失败')
      }
      this.loading = false
    },
    addMachineInfo () {
      this.flag = 0
      this.visible = true
    },
    removeMachineInfo () {
      if (this.selectedMachineList.length === 0) {
        return message.warn('请选择要删除的选项')
      }
      for (let i = 0; i < this.selectedMachineList.length; i++) {
        if (typeof this.selectedMachineList[i].id === 'string') return message.warning('请勿删除已监控的设备')
      }
      this.deletevisible = true
    },
    async handledelete () {
      const ids = []
      for (let i = 0; i < this.selectedMachineList.length; i++) {
        for (let j = 0; j < this.machineList.length; j++) {
          if (this.selectedMachineList[i].id === this.machineList[j].id) {
            console.log(this.machineList[j])
            ids.push(this.machineList[j].id)
            this.machineList.splice(j, 1)
          }
        }
      }
      try {
        const result = await machineApi.removeMachine(ids)
        this.selectedMachineList = []
        this.deletevisible = false
        console.log(result)
      } catch {
        this.$message.error('请求失败')
      }
    },
    editMachineInfo () {
      if (this.selectedMachineList.length > 1) return message.warn('一次只能编辑一个选项')
      if (this.selectedMachineList.length === 0) return message.warn('请选择一个要编辑的选项')
      this.flag = 1 // edit
      // for (let i = 0; i < this.selectedMachineList.length; i++) {
      //   for (let j = 0; j < this.machineList.length; j++) {
      //     if (this.selectedMachineList[i].machineid === this.machineList[j].machineid) {
      //       this.insertData = this.machineList[j]
      //       console.log(j)
      //       this.index = j
      //     }
      //   }
      // }
      if (typeof this.selectedMachineList[0].id === 'string') return message.warn('该设备已监控，无需手动编辑')
      for (let i = 0; i < this.machineList.length; i++) {
        if (this.machineList[i].id === this.selectedMachineList[0].id) {
          console.log(this.selectedMachineList[0])
          this.insertData = this.selectedMachineList[0]
          this.index = i
          console.log(i)
        }
      }
      console.log(this.insertData)
      this.maintainSetTime = this.insertData.maintainSetTime
      this.runtime = this.insertData.runtime
      this.price = this.insertData.price
      this.lastMaintainTime = this.insertData.lastMaintainTime
      this.salesTime = this.insertData.salesTime
      this.visible = true
    },
    async handleOk () {
      // if (!this.insertData.machineId) return message.warn('编号为空')
      // if (!this.insertData.machineType) return message.warn('机型为空')
      // if (!this.insertData.salesman) return message.warn('业务员为空')
      // if (!this.insertData.serviceName) return message.warn('服务员为空')
      // if (!this.salesTime) return message.warn('出厂日期为空')
      // if (!this.maintainSetTime) return message.warn('保养时间为空')
      // if (!this.runtime) return message.warn('每天运行时间为空')
      // if (!this.lastMaintainTime) return message.warn('上次保养日期为空')
      console.log(this.insertData)
      if (this.flag === 0) {
        console.log(this.insertData)
        const obj = {
          machineId: this.insertData.machineId,
          machineType: this.insertData.machineType,
          salesman: this.insertData.salesman,
          serviceName: this.insertData.serviceName,
          salesTime: new Date(this.insertData.salesTime).getTime(),
          maintainSetTime: this.insertData.maintainSetTime * 1,
          runtime: this.insertData.runtime * 1,
          lastMaintainTime: new Date(this.insertData.lastMaintainTime).getTime(),
          remark: this.insertData.remark,
          customerId: this.companyData.fcustId * 1,
          price: this.insertData.price
        //   // machineId: this.insertData.machineId,
        //   // machineType: this.insertData.machineType,
        //   // salesman: this.insertData.salesman,
        //   // serviceName: this.insertData.serviceName,
        //   // salesTime: this.insertData.salesTime,
        //   // maintainSetTime: this.insertData.maintainSetTime,
        //   // runtime: this.insertData.runtime,
        //   // lastMaintainTime: this.insertData.lastMaintainTime,
        //   // maintainDate: this.insertData.maintainDate,
        //   // remark: this.insertData.remark,
        //   // customerId: this.companyData.fcustId
        }
        console.log(obj)
        try {
          await machineApi.addMachineList(obj)
          const reportData = await machineApi.getMachineList(this.companyData.fcustId, this.currentPage, this.pageSize)
          reportData.records.forEach((item, index) => {
            item.lastMaintainTime = !item.lastMaintainTime ? '' : this.formatDate(item.lastMaintainTime)
            item.salesTime = !item.salesTime ? '' : this.formatDate(item.salesTime)
            item.exceptMaintainDate = !item.exceptMaintainDate ? '' : this.formatDate(item.exceptMaintainDate)
            if (!item.id) {
              item.id = nanoid()
              item.remark = '(已监控)'
            }
          })
          console.log(reportData)
          this.machineList = reportData.records.reverse()
        } catch {
          this.$message.error('请求失败')
        }
      } else {
        const obj = {
          id: this.selectedMachineList[0].id,
          machineId: this.insertData.machineId,
          machineType: this.insertData.machineType,
          salesman: this.insertData.salesman,
          serviceName: this.insertData.serviceName,
          salesTime: new Date(this.insertData.salesTime).getTime(),
          maintainSetTime: this.insertData.maintainSetTime * 1,
          runtime: this.insertData.runtime * 1,
          lastMaintainTime: new Date(this.insertData.lastMaintainTime).getTime(),
          remark: this.insertData.remark,
          customerId: this.companyData.fcustId * 1,
          price: this.insertData.price * 1
        }
        try {
          const result = await machineApi.addMachineList(obj)
          console.log(result)
          const reportData = await machineApi.getMachineList(this.companyData.fcustId, this.currentPage, this.pageSize)
          reportData.records.forEach((item, index) => {
            item.lastMaintainTime = !item.lastMaintainTime ? '' : this.formatDate(item.lastMaintainTime)
            item.salesTime = !item.salesTime ? '' : this.formatDate(item.salesTime)
            item.exceptMaintainDate = !item.exceptMaintainDate ? '' : this.formatDate(item.exceptMaintainDate)
            if (!item.id) {
              item.id = nanoid()
              item.remark = '(已监控)'
            }
          })
          console.log(reportData)
          this.machineList = reportData.records.reverse()
        } catch {
          this.$message.error('请求失败')
        }
      }
      this.visible = false
      this.runtime = ''
      this.price = ''
      this.lastMaintainTime = ''
      this.salesTime = ''
      this.maintainSetTime = ''
      this.insertData = {}
    },
    handleCancel () {
      this.insertData = {}
      this.visible = false
      this.runtime = ''
      this.lastMaintainTime = ''
      this.salesTime = ''
      this.maintainSetTime = ''
    },
    lastChange (date, dateString) {
      console.log(date, dateString)
      this.lastMaintainTime = dateString
    },
    salesTimeChange (_, dateString) {
      this.salesTime = dateString
    },
    goback () {
      if (this.routeFlag === 1) {
        this.$router.back()
      } else {
        this.inputShow = true
        this.companyVisible = true
        this.visible = false
        // console.log(this.companyVisible, this.visible)
        // this.$forceUpdate()
      }
    }
  },
  computed: {
    maintainDate () {
      return this.maintainSetTime && this.lastMaintainTime && this.runtime
        ? parseInt(((this.maintainSetTime * 1 - ((new Date().getTime() - new Date(this.lastMaintainTime).getTime()) / (1000 * 60 * 60 * 24)) * (this.runtime * 1)) / (this.runtime * 1)))
        : ''
    },
    exceptMaintainDate () {
      const date = new Date().getTime() + this.maintainDate * 1000 * 60 * 60 * 24
      console.log(date)
      return this.maintainDate ? this.formatDate(date) : ''
    }
    // rowSelection () {
    //   return {
    //     preserveSelectedRowKeys: false,
    //     onChange: (selectedRowKeys, selectedRows) => {
    //       console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
    //       this.selectedMachineList = selectedRows
    //       console.log(selectedRows)
    //     }
    //   }
    // }
  }
}
</script>

<style scoped>
.companyInfo {
  width: 100%;
  padding-top: 40px;
  margin-bottom: 40px;
  background-color: #eee;
  text-align: center;
  box-sizing: border-box;
}
.companyInfo p {
  float: left;
  width: 50%;
  font-size: 20px;
  font-weight: 500;
  padding-left: 30px;
}
.companyInfo button {
  width: 100px;
  height: 50px;
  font-size: 18x;
  margin: 0 0 20px 15px;
}
.ant-modal-body span {
  display: inline-block;
  width: 30%;
}
.ant-modal-body input {
  outline: none;
  border: 1px solid #ccc;
  width: 70%;
}
.ant-modal-body input.exceptMaintainDate,
.ant-modal-body input.exceptMaintainDate {
  width: 30%;
}
.ant-modal-body input.ant-calendar-picker-input ::placeholder {
  color: red;
}
.ant-popover-inner-content {
  width: 80px
}
/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(240, 240, 241)
}
</style>
